import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/dashboard/PageHeader";
import { PropertiesCard } from "@/components/dashboard/PropertiesCard";
import { TenantsTable } from "@/components/dashboard/TenantsTable";
import { AddTenantDialog } from "@/components/dashboard/AddTenantDialog";

const Stat = ({ label, value, dot, testid }) => (
  <div className="surface p-5">
    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-500">{dot && <span className={`h-2.5 w-2.5 rounded-full ${dot}`} />}{label}</p>
    <p data-testid={testid} className="font-display mt-3 text-3xl font-bold text-[#0f172a]">{value}</p>
  </div>
);

export function Overview() {
  const [properties, setProperties] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [p, t] = await Promise.all([api.get("/properties"), api.get("/tenants")]);
      setProperties(p.data);
      setTenants(t.data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  const count = (s) => tenants.filter((t) => t.status === s).length;

  return (
    <div>
      <PageHeader eyebrow="Panoramica" title="I tuoi immobili" text="Monitora i canoni del mese corrente con il semaforo dei pagamenti.">
        <AddTenantDialog properties={properties} onCreated={load} />
      </PageHeader>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Immobili" value={properties.length} testid="stat-immobili" />
        <Stat label="Regolari" value={count("regolare")} dot="bg-[#16a34a]" testid="stat-regolari" />
        <Stat label="In scadenza" value={count("in_scadenza")} dot="bg-amber-500" testid="stat-in-scadenza" />
        <Stat label="In ritardo" value={count("in_ritardo")} dot="bg-[#dc2626]" testid="stat-in-ritardo" />
      </div>
      <div className="mt-8 grid gap-8 xl:grid-cols-[1fr_340px]">
        <TenantsTable tenants={tenants} properties={properties} loading={loading} onChange={load} />
        <PropertiesCard properties={properties} onChange={load} />
      </div>
    </div>
  );
}
